export enum MessageStatus {
  APPROVED = 'approved',
  DRAFT = 'draft',
  PROPOSED = 'proposed',
  DEPRECATED = 'deprecated',
  END_OF_SUPPORT = 'end of support',
  UNKNOWN = 'unknown',
}
